// see for details:
// https://vue-crud.github.io/guide/crud/field-options.html
export default {
  computed: {
    fieldsInfo () {
      return [
        {
          text: this.$t('fields.id'),
          name: 'id',
          details: false,
          table: false,
        },
        {
          // type: 'input',
          column: 'task_id',
          text: this.$t('fields.task_id'),
          multiedit: false,
          required: true,
          create: false,
          edit: false,
          details: false,
          table: false,
        },
        {
          type: 'textarea',
          column: 'text',
          text: this.$t('fields.text'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'text',
          multiedit: false,
          required: true,
          details: true,
          edit: true,
        },
        {
          type: 'date',
          column: 'created',
          text: this.$t('fields.created'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'created',
          multiedit: false,
          details: false,
          edit: false,
          create: false,
        },
        {
          type: 'date',
          column: 'updated',
          text: this.$t('fields.updated'),
          grid: 'xs12 sm6 md4 lg6 xl4',
          name: 'updated',
          multiedit: false,
          details: false,
          edit: false,
          create: false,
        },
      ]
    },
  },
}
